import "./MainLayout.scss";

export const MainLayout: React.FunctionComponent = ({ children }) => {
  return <div className="mainLayout">{children}</div>;
};
